import ApiBase from "./ApiBase";

const AuditLogsApi = {
  // Fetch all audit logs with optional query parameters
  fetchAll(params = {}) {
    return ApiBase.get("/audit_logs", params);
  },

  // Fetch suggestions for the search input
  fetchSuggestions(query) {
    return ApiBase.get("/audit_logs/suggestions", { query });
  },

  // Fetch audit logs for a specific STYLE_COLOR
  fetchLogsByStyleColor(styleColor) {
    return ApiBase.get("/audit_logs/fetch_logs", { style_color: styleColor });
  },
};

export default AuditLogsApi;
